<script>
    import {createEventDispatcher} from "svelte";

    export let scene = 0;
    const dispatch = createEventDispatcher();

    const gnosisHitAreas = [
        {x: 605, y: 475},
        {x: 1220, y: 500},
        {x: 605, y: 700},
        {x: 1220, y: 730},
    ];

    const telescopeHitAreas = [
        {x: 1250, y: 550},
        {x: 1270, y: 820},
    ];

    const nineLeadersHitAreas = [
        {x: 710, y: 580},
        {x: 840, y: 565},
        {x: 970, y: 580},
        {x: 1080, y: 580},
        {x: 1190, y: 580},
        {x: 770, y: 780},
        {x: 885, y: 780},
        {x: 1030, y: 780},
        {x: 1140, y: 780},
    ];

    const pathHitAreas = [
        {x: 800, y: 560},
        {x: 1190, y: 660},
    ];

    const magnifyingGlassHitAreas = [
        {x: 855, y: 615},
        {x: 945, y: 645},
        {x: 1030, y: 615},
    ];

    const threeLeadersHitAreas = [
        {x: 680, y: 410},
        {x: 890, y: 330},
        {x: 1085, y: 410},
    ];


    function goToSubScene(subScene) {
        dispatch('go-to-sub-scene', {
            subScene,
        });
    }

    function goToScene(scene) {
        dispatch('go-to-scene', {
            scene,
        });
    }

    $: showGnosisHitAreas = scene === 3;
    $: showTelescopeHitAreas = scene === 4;
    $: showNineLeadersHitAreas = scene === 6;
    $: showPathHitAreas = scene === 7;
    $: showMagnifyingGlassHitAreas = scene === 8;
    $: showThreeLeadersHitAreas = scene === 9;

</script>

{#if showGnosisHitAreas}
    <svg viewBox="0 0 1920 1080" width="100%" class="hit-area-svg">
        {#each gnosisHitAreas as hitArea, i}
            <g class="hit-area">
                <rect
                        width="80"
                        height="80"
                        class="hit-rect"
                        x={hitArea.x}
                        y={hitArea.y}
                        on:click={() => goToSubScene(i)}
                ></rect>
            </g>
        {/each}
    </svg>
{/if}

{#if showTelescopeHitAreas}
    <svg viewBox="0 0 1920 1080" width="100%" class="hit-area-svg">
        {#each telescopeHitAreas as hitArea, i}
            <g class="hit-area">
                <rect
                        width="80"
                        height="80"
                        class="hit-rect"
                        x={hitArea.x}
                        y={hitArea.y}
                        on:click={() => goToSubScene(i)}
                ></rect>
            </g>
        {/each}
    </svg>
{/if}

{#if showNineLeadersHitAreas}
    <svg viewBox="0 0 1920 1080" width="100%" class="hit-area-svg">
        {#each nineLeadersHitAreas as hitArea, i}
            <g class="hit-area">
                <ellipse
                        rx="50"
                        ry="135"
                        class="hit-rect"
                        cx={hitArea.x}
                        cy={hitArea.y}
                        on:click={() => goToSubScene(i)}
                ></ellipse>
            </g>
        {/each}
    </svg>
{/if}

{#if showPathHitAreas}
    <svg viewBox="0 0 1920 1080" width="100%" class="hit-area-svg">

        <g class="hit-area">
            <rect
                    width="80"
                    height="80"
                    class="hit-rect"
                    x={1030}
                    y={870}
                    on:click={() => goToScene(7)}
            ></rect>
        </g>
        {#each pathHitAreas as hitArea, i}
            <g class="hit-area">
                <rect
                        width="80"
                        height="80"
                        class="hit-rect"
                        x={hitArea.x}
                        y={hitArea.y}
                        on:click={() => goToSubScene(i + 1)}
                ></rect>
            </g>
        {/each}
    </svg>
{/if}

{#if showMagnifyingGlassHitAreas}
    <svg viewBox="0 0 1920 1080" width="100%" class="hit-area-svg">
        {#each magnifyingGlassHitAreas as hitArea, i}
            <g class="hit-area">
                <rect
                        width="70"
                        height="70"
                        class="hit-rect"
                        x={hitArea.x}
                        y={hitArea.y}
                        on:click={() => goToSubScene(i)}
                ></rect>
            </g>
        {/each}
    </svg>
{/if}

{#if showThreeLeadersHitAreas}
    <svg viewBox="0 0 1920 1080" width="100%" class="hit-area-svg">
        {#each threeLeadersHitAreas as hitArea, i}
            <g class="hit-area">
                <rect
                        width="150"
                        height="460"
                        class="hit-rect"
                        x={hitArea.x}
                        y={hitArea.y}
                        on:click={() => goToSubScene(i)}
                ></rect>
            </g>
        {/each}
    </svg>
{/if}


<style>

    .hit-area {
        cursor: pointer;
    }

    .hit-rect {
        fill: rgba(0, 0, 0, 0);
    }

    .hit-area-svg {
        position: absolute;
        top: 0;
        left: 0;
    }
</style>
